import { SVG, SVGProps } from './svg'

export function IconFlash(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M18 10.2l-7 11.4c0 .3-.3.4-.6.4h-.2s-.2 0-.3-.2a.5.5 0 01-.2-.3l.6-6.5H6.7a.8.8 0 01-.6-.4l-.2-.3a.5.5 0 010-.5l7-11.4c.1-.3.4-.4.7-.4h.2c.1 0 .2 0 .3.2l.2.3-.6 6.5h3.6c.2 0 .5.1.6.4l.2.3v.5z" />
    </SVG>
  )
}
